import { jwtDecode } from 'jwt-decode';
import { PartnerValidationFieldsRequest } from '../partner';

export const ppDataObject = 'https://oneid.calm.com/sso_data';

export type PartnerPortalData = PartnerValidationFieldsRequest & {
    partner_id?: string;
};

export interface JwtPayload {
    iss?: string;
    sub?: string;
    aud?: string[] | string;
    exp?: number;
    nbf?: number;
    iat?: number;
    jti?: string;
    [ppDataObject]?: PartnerPortalData;
}

export const NEW_ACCOUNT_PREFIX = 'samlp';
export const SAML_TOKEN_STORAGE_KEY = 'SSO_SAML_TOKEN';
export const SAML_USER_ID_STORAGE_KEY = 'SSO_SAML_USERID';

export function getSSOSessionStorageData() {
    const ssoToken = getStoredIdpToken();
    const ssoUserId = getStoredUserId();

    const ssoObject = ssoToken
        ? getPartnerPortalTokenData(ssoToken)
        : undefined;
    const isSamlUser = ssoUserId
        ? getIsSamlUserToken({ sub: ssoUserId })
        : false;

    return {
        ssoToken,
        ssoUserId,
        isInitialSSO: Boolean(ssoToken),
        isLinkedSsoUser: Boolean(ssoObject && !isSamlUser),
        isPreviouslySamlUser: Boolean(isSamlUser),
    };
}

export function getIsInitialSSO() {
    const { isInitialSSO } = getSSOSessionStorageData();
    return isInitialSSO;
}

export function getIsLinkedSsoUser() {
    const { isLinkedSsoUser } = getSSOSessionStorageData();
    return isLinkedSsoUser;
}

export function getIsPreviouslySamlUser() {
    const { isPreviouslySamlUser } = getSSOSessionStorageData();
    return isPreviouslySamlUser;
}

export function getIsSamlUserToken(subContainer?: { sub?: string }) {
    return !!subContainer?.sub?.includes(NEW_ACCOUNT_PREFIX);
}

export function getStoredIdpToken() {
    return sessionStorage.getItem(SAML_TOKEN_STORAGE_KEY);
}

export function setStoredIdpToken(token: string) {
    sessionStorage.setItem(SAML_TOKEN_STORAGE_KEY, token);
}

export function getStoredUserId() {
    return sessionStorage.getItem(SAML_USER_ID_STORAGE_KEY);
}

export function setStoredUserId(userId: string) {
    sessionStorage.setItem(SAML_USER_ID_STORAGE_KEY, userId);
}

export function clearSAMLStorage() {
    sessionStorage.removeItem(SAML_TOKEN_STORAGE_KEY);
    sessionStorage.removeItem(SAML_USER_ID_STORAGE_KEY);
}

export function getPartnerPortalTokenData(token: string) {
    if (!token) {
        return {
            partner_id: '',
            subscriber_id: '',
            first_name: '',
            last_name: '',
            dob: '',
        };
    }

    const decodedToken = jwtDecode<JwtPayload>(token);
    const decodedTokenObj = decodedToken[ppDataObject] as PartnerPortalData;
    return decodedTokenObj;
}
